import { Box, Button, Container, Divider, Paper, Tabs, Typography } from '@mui/material';
import DataTable from '../common/DataTable';
import Header from '../common/Header/Header';
import Loading from '../common/Loading';
import NoResultsFound from '../common/NoResultsFound';
import SearchWithoutFilter from '../common/SearchWithoutFIlter';
import styles from './styles';
import { NewMemberRequestProps } from './types';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} {...other}>
            {value === index && (
                <Box sx={{ p: 3, backgroundColor: 'none' }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const NewMemberRequestManagement = ({
    loader,
    openProfileDetails,
    pendingAndResolved,
    pendingColumnSpec,
    pendingCount,
    pendingData,
    pendingHasMore,
    pendingLoadMore,
    resolvedColumnSpec,
    resolvedCount,
    resolvedData,
    resolvedHasMore,
    resolvedLoadMore,
    setOpenProfileDetails,
    setPendingAndResolved,
    setPendingCurrentPage,
    user,
    handleRowClick,
    onPendingSearchChange,
    onResolvedSearchChange,
    pendingSortData,
    resolvedSortData,
}: NewMemberRequestProps) => {
    return (
        <Container sx={styles.container} maxWidth={false}>
            <Header
                profileImg={user.profileImg}
                name={user.name}
                titleComponent={
                    <Typography component="div" sx={styles.header}>
                        <Typography id="new_member_request_title" component="div" sx={styles.title}>
                            New Member Requests
                        </Typography>
                    </Typography>
                }
                setOpenProfileDetails={setOpenProfileDetails}
                openProfileDetails={openProfileDetails}
            />
            <Paper elevation={1} sx={styles.table}>
                <Typography component="div" sx={styles.newMemberRequest}>
                    <Typography component="div" sx={styles.root}>
                        <Tabs
                            value={pendingAndResolved}
                            TabIndicatorProps={{
                                style: styles.tabIndicator,
                            }}
                        >
                            <Typography component="div">
                                <Button
                                    id="pending-requests"
                                    variant={pendingAndResolved === 0 ? 'contained' : 'outlined'}
                                    sx={styles.pendingRequestButton}
                                    onClick={() => setPendingAndResolved(0)}
                                >
                                    Pending ({pendingCount})
                                </Button>
                            </Typography>

                            <Typography component="div">
                                <Button
                                    id="resolved-requests"
                                    variant={pendingAndResolved === 1 ? 'contained' : 'outlined'}
                                    sx={styles.resolvedRequestButton}
                                    onClick={() => {
                                        setPendingCurrentPage(1);
                                        setPendingAndResolved(1);
                                    }}
                                >
                                    Resolved ({resolvedCount})
                                </Button>
                            </Typography>
                        </Tabs>
                    </Typography>

                    <TabPanel value={pendingAndResolved} index={0}>
                        <Typography component="div" sx={styles.newMemberRequest}>
                            <Typography component="div">
                                <SearchWithoutFilter
                                    id="pending-search"
                                    placeholder="Search..."
                                    searchChange={onPendingSearchChange}
                                />
                            </Typography>
                        </Typography>
                    </TabPanel>

                    <TabPanel value={pendingAndResolved} index={1}>
                        <Typography component="div" sx={styles.newMemberRequest}>
                            <Typography component="div">
                                <SearchWithoutFilter
                                    id="resolved-search"
                                    placeholder="Search..."
                                    searchChange={onResolvedSearchChange}
                                />
                            </Typography>
                        </Typography>
                    </TabPanel>
                </Typography>

                <Divider sx={styles.divider} />
                {/* eslint-disable no-nested-ternary */}
                {loader ? (
                    <Loading />
                ) : (pendingAndResolved === 0 && pendingData.length > 0) ||
                  (pendingAndResolved === 1 && resolvedData.length > 0) ? (
                    <>
                        <TabPanel value={pendingAndResolved} index={0}>
                            <DataTable
                                columns={pendingColumnSpec}
                                data={pendingData}
                                loadMore={pendingLoadMore}
                                hasMore={pendingHasMore}
                                handleRowClick={handleRowClick}
                                sortData={pendingSortData}
                            />
                        </TabPanel>
                        <TabPanel value={pendingAndResolved} index={1}>
                            <DataTable
                                columns={resolvedColumnSpec}
                                data={resolvedData}
                                loadMore={resolvedLoadMore}
                                hasMore={resolvedHasMore}
                                sortData={resolvedSortData}
                            />
                        </TabPanel>
                    </>
                ) : (
                    ((pendingAndResolved === 0 && pendingData.length === 0) ||
                        (pendingAndResolved === 1 && resolvedData.length === 0)) && <NoResultsFound />
                )}
            </Paper>
        </Container>
    );
};

export default NewMemberRequestManagement;
